module.exports = __webpack_public_path__ + "img/signal-bars-slash.ab83e976.svg";